<era-pane>
  <h5 class="small-caps"
      i18n>Device Name</h5>
  <form [formGroup]="deviceNameForm"
        (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <label class="form-label"
             for="deviceName">Set the device's name</label>
      <input id="deviceName"
             formControlName="deviceName"
             required="true"
             class="form-control"
             placeholder="My device name" />
    </div>
    <button class="btn btn-primary"
            type="submit"
            [disabled]="!deviceNameForm.valid">Submit</button>
  </form>
</era-pane>